import React from 'react'
import ReactDOM from 'react-dom/client'
import { AppInsightsContext, AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js'

import { insightsPlugin, startApplicationInsights } from './Insights'
import App from './App'
import AppStoreProvider from './stores/AppStoreProvider'
import SystemError from './pages/systems/SystemError'

import './theme/yamadumi.css'
import './theme/yamadumi-other.css'
import './index.css'

startApplicationInsights()

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
root.render(
  <React.StrictMode>
    <AppInsightsContext.Provider value={insightsPlugin}>
      <AppInsightsErrorBoundary appInsights={insightsPlugin} onError={() => <SystemError />}>
        <AppStoreProvider>
          <App />
        </AppStoreProvider>
      </AppInsightsErrorBoundary>
    </AppInsightsContext.Provider>
  </React.StrictMode>
)
